module.exports = __webpack_public_path__ + "js/components/images/google_play_white-d31c1a6fba47e6d69698acd96d233148.svg";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/google_play_white.svg
// module id = 826
// module chunks = 31